import './boulevard/style';
import FormStructure from './boulevard/form_structure';

export default FormStructure;